import { useI18n, usePortfolioData } from "../i18n";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Socials from "../components/about/socials";

import styles from "./styles/contact.module.css";

const Contact = () => {
  const { user: INFO, seo: SEO } = usePortfolioData();
  const { t } = useI18n();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSEO = SEO.find((item) => item.page === "contact");

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t("contact")} | ${INFO.main.title}`}</title>
        <meta name="description" content={currentSEO.description} />
        <meta name="keywords" content={currentSEO.keywords.join(", ")} />
      </Helmet>

      <div className="page-content">
        <NavBar active="contact" />
        <div className="content-wrapper">
          <div className={styles["contact-container"]}>
            <div className="title">{INFO.contact.title}</div>

            <div className="subtitle">{INFO.contact.description}</div>
          </div>

          <div className={styles["socials-container"]}>
            <div className={styles["contact-socials"]}>
              <Socials />
            </div>
          </div>

          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Contact;
